import React from 'react';
import Banner from '../../../components/Banner/Banner';
import './Projeler.css';

const Projeler = () => {
  // The following HTML string contains the content from the original "Projeler" page.
  const projectsHTML = `
<div data-elementor-type="wp-page" data-elementor-id="277" class="elementor elementor-277">
  <section class="elementor-section elementor-top-section elementor-element elementor-element-cb9d123 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="cb9d123" data-element_type="section">
    <div class="elementor-background-overlay"></div>
    <div class="elementor-container elementor-column-gap-default">
      <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-6174c36" data-id="6174c36" data-element_type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-a05669b elementor-widget elementor-widget-image" data-id="a05669b" data-element_type="widget" data-widget_type="image.default">
            <div class="elementor-widget-container">
              <img fetchpriority="high" decoding="async" width="612" height="1024" src="https://teknoma.net/wp-content/uploads/2020/01/oled-612x1024.png" class="attachment-large size-large wp-image-651" alt="" srcset="https://teknoma.net/wp-content/uploads/2020/01/oled-612x1024.png 612w, https://teknoma.net/wp-content/uploads/2020/01/oled-179x300.png 179w, https://teknoma.net/wp-content/uploads/2020/01/oled-600x1004.png 600w, https://teknoma.net/wp-content/uploads/2020/01/oled.png 736w" sizes="(max-width: 612px) 100vw, 612px" />
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b22c778" data-id="b22c778" data-element_type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-1d5d6c4 elementor-widget elementor-widget-spacer" data-id="1d5d6c4" data-element_type="widget" data-widget_type="spacer.default">
            <div class="elementor-widget-container">
              <div class="elementor-spacer">
                <div class="elementor-spacer-inner"></div>
              </div>
            </div>
          </div>
          <div class="elementor-element elementor-element-b6e476b elementor-widget elementor-widget-text-editor" data-id="b6e476b" data-element_type="widget" data-widget_type="text-editor.default">
            <div class="elementor-widget-container">
              <h3 style="text-align: center;">
                <span style="color: #000000;">OLED'ler için Esnek Altlıklar Üzerine Rulodan Ruloya Optik Geçirgen Elektriksel İletken Kaplamalar</span>
              </h3>
              <p style="text-align: center;"><span style="color: #000000;">(TUBİTAK – TEYDEB / Devam Ediyor)</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="elementor-section elementor-top-section elementor-element elementor-element-692f15f elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="692f15f" data-element_type="section">
    <div class="elementor-container elementor-column-gap-default">
      <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-576193f" data-id="576193f" data-element_type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-79509c8 elementor-widget elementor-widget-spacer" data-id="79509c8" data-element_type="widget" data-widget_type="spacer.default">
            <div class="elementor-widget-container">
              <div class="elementor-spacer">
                <div class="elementor-spacer-inner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="elementor-section elementor-top-section elementor-element elementor-element-0c102cd elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="0c102cd" data-element_type="section">
    <div class="elementor-container elementor-column-gap-default">
      <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-625f165" data-id="625f165" data-element_type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-58a37bc elementor-widget elementor-widget-text-editor" data-id="58a37bc" data-element_type="widget" data-widget_type="text-editor.default">
            <div class="elementor-widget-container">
              <h3 style="text-align: center;">
                <span style="color: #000000;">Tekstil ve Diğer Konularda Projeler</span>
              </h3>
              <p style="text-align: center;">
                <span style="color: #000000;">(Projelerin detayları için ilgili başlıklara tıklayınız)</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-e52a204" data-id="e52a204" data-element_type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-1874d1a elementor-widget elementor-widget-spacer" data-id="1874d1a" data-element_type="widget" data-widget_type="spacer.default">
            <div class="elementor-widget-container">
              <div class="elementor-spacer">
                <div class="elementor-spacer-inner"></div>
              </div>
            </div>
          </div>
          <div class="elementor-element elementor-element-5e71f1c elementor-widget elementor-widget-image" data-id="5e71f1c" data-element_type="widget" data-widget_type="image.default">
            <div class="elementor-widget-container">
              <img loading="lazy" decoding="async" width="198" height="155" src="https://teknoma.net/wp-content/uploads/2019/10/12EAE7B5-934A-45A5-BDB7-E5EE24A1126B.jpeg" class="attachment-large size-large wp-image-243" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="elementor-section elementor-top-section elementor-element elementor-element-a03b1a5 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="a03b1a5" data-element_type="section">
    <div class="elementor-container elementor-column-gap-default">
      <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e802883" data-id="e802883" data-element_type="column">
        <div class="elementor-widget-wrap">
        </div>
      </div>
    </div>
  </section>
  <section class="elementor-section elementor-top-section elementor-element elementor-element-040b117 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="040b117" data-element_type="section">
    <div class="elementor-container elementor-column-gap-default">
      <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-625f165" data-id="625f165" data-element_type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-8e0f23d elementor-widget elementor-widget-text-editor" data-id="8e0f23d" data-element_type="widget" data-widget_type="text-editor.default">
            <div class="elementor-widget-container">
              <h5 style="text-align: center;">OLED'ler için Esnek Altlıklar Üzerine Rulodan Ruloya Optik Geçirgen Elektriksel İletken Kaplamalar</h5>
              <p style="text-align: center;"><span style="color: #000000;">(TUBİTAK – TEYDEB / Devam Ediyor)</span></p>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-ec099d6" data-id="ec099d6" data-element_type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-410242e elementor-widget elementor-widget-spacer" data-id="410242e" data-element_type="widget" data-widget_type="spacer.default">
            <div class="elementor-widget-container">
              <div class="elementor-spacer">
                <div class="elementor-spacer-inner"></div>
              </div>
            </div>
          </div>
          <div class="elementor-element elementor-element-b826c72 elementor-widget elementor-widget-text-editor" data-id="b826c72" data-element_type="widget" data-widget_type="text-editor.default">
            <div class="elementor-widget-container">
              <h3 style="text-align: center;">
                <span style="color: #000000;">Indiyum Kalay Oksit İletken Saydam Filmlerin Oto ve Vitrifiye Sanayisindeki Uygulamaları</span>
              </h3>
              <p style="text-align: center;"><span style="color: #000000;">(SANTEZ / Tamamlandı)</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
`;

  return (
    <div className="projeler-page">
      {/* Banner */}
      <Banner 
        title="Projeler" 
        backgroundImage="https://teknoma.net/wp-content/themes/bizler/assets/img/inner-banner.jpg"
      />

      {/* Page Content */}
      <section className="projeler-content">
        <div className="container content-container">
          <div dangerouslySetInnerHTML={{ __html: projectsHTML }} />
        </div>
      </section>
    </div>
  );
};

export default Projeler;